/** 제휴사 관리 API (8-1) 요청 DTO */

export interface getPartnerListForm {
  page: number
  size: number
}

/** POST /v1/partner, PATCH /v1/partner/{partnerId} 공통 바디 */
export interface partnerForm {
  partnerName: string
  /** YYYY-MM-DD */
  activeFrom: string
  /** YYYY-MM-DD */
  activeTo: string
  /** 어드민이 켜둔 활성화 설정 — 실제 활성 여부(isActive)는 서버가 checkActive && 기간으로 계산 */
  checkActive: boolean
  /** 연결 링크 path (ex. opgg) */
  link: string
  /** 상담 링크 */
  contactLink: string
  /** 백업 지점 여부 */
  isBackup: boolean
  /** 공급업체(지점) id — GET /v1/partner/store 항목의 id. 없으면 null */
  referenceStoreId: number | null
}

export const initPartnerForm: partnerForm = {
  partnerName: '',
  activeFrom: '',
  activeTo: '',
  checkActive: false,
  link: '',
  contactLink: '',
  isBackup: false,
  referenceStoreId: null,
}

/**
 * 유저향 제휴 페이지 URL — link(slug) 를 붙여서 만든다.
 * ex) moongcheap → https://modusj.com/historyStore/moongcheap
 */
export const PARTNER_PAGE_BASE_URL = 'https://modusj.com/historyStore'
export const partnerPageUrl = (link: string | null | undefined) =>
  link ? `${PARTNER_PAGE_BASE_URL}/${link}` : ''

/** POST /v1/partner/{partnerId}/upload — 제휴사 이미지 업로드/삭제 (PROFILE=로고, BANNER=배너, SHARE=카카오톡 공유) */
export type PARTNER_IMAGE_TYPE = 'BANNER' | 'PROFILE' | 'SHARE'
export interface partnerImageUploadForm {
  partnerId: number | string
  imageType: PARTNER_IMAGE_TYPE
  /** 업로드할 파일 (multipartFile). delete=true 면 생략 */
  file?: File | null
  /** true 면 해당 이미지 삭제 */
  delete?: boolean
}

/** GET /v1/partner/quotation/reference/{storeId} 쿼리 */
export interface partnerQuotationReferenceForm {
  storeId: number | string
  /** 만원 단위 일괄 가감 */
  addAmount?: number
  /** 부가서비스도 함께 불러올지 */
  useAddService?: boolean
}
